/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkGoogleReviewDto } from '../models/work-google-review-dto';
import { WorkGoogleReviewOverallDto } from '../models/work-google-review-overall-dto';

@Injectable({ providedIn: 'root' })
export class WorkWebsiteGoogleReviewsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `websiteGoogleReviewsV2ControllerGetAllGoogleReviews()` */
  static readonly WebsiteGoogleReviewsV2ControllerGetAllGoogleReviewsPath = '/v2/website/google-reviews';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteGoogleReviewsV2ControllerGetAllGoogleReviews()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteGoogleReviewsV2ControllerGetAllGoogleReviews$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkGoogleReviewDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteGoogleReviewsV2Service.WebsiteGoogleReviewsV2ControllerGetAllGoogleReviewsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkGoogleReviewDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteGoogleReviewsV2ControllerGetAllGoogleReviews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteGoogleReviewsV2ControllerGetAllGoogleReviews(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkGoogleReviewDto>> {
    return this.websiteGoogleReviewsV2ControllerGetAllGoogleReviews$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkGoogleReviewDto>>): Array<WorkGoogleReviewDto> => r.body)
    );
  }

  /** Path part for operation `websiteGoogleReviewsV2ControllerGetOverallGoogleReview()` */
  static readonly WebsiteGoogleReviewsV2ControllerGetOverallGoogleReviewPath = '/v2/website/google-reviews/overall';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteGoogleReviewsV2ControllerGetOverallGoogleReview()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteGoogleReviewsV2ControllerGetOverallGoogleReview$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkGoogleReviewOverallDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteGoogleReviewsV2Service.WebsiteGoogleReviewsV2ControllerGetOverallGoogleReviewPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkGoogleReviewOverallDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteGoogleReviewsV2ControllerGetOverallGoogleReview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteGoogleReviewsV2ControllerGetOverallGoogleReview(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkGoogleReviewOverallDto> {
    return this.websiteGoogleReviewsV2ControllerGetOverallGoogleReview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkGoogleReviewOverallDto>): WorkGoogleReviewOverallDto => r.body)
    );
  }

}
